import { Component } from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import "./Login.css";
import { authenticateUser, loadActiveUser } from "../redux/users/usersActions";
import { withRouter } from "react-router-dom";
import logo from "../images/Logo.png";
import Paper from "@mui/material/Paper";
import Background from "../images/background_cesbron.png";
import { getDefaultSyncState, getSynchroActiveUser, getAllData } from "../redux/synchro/synchroActions";
import { Button } from "@mui/material/";
import { GoogleLogin as NewGoogleLogin } from '@react-oauth/google';
import jwt_decode from "jwt-decode";

const styles = {
    bgImage: {
        maxWidth: "90%",
        maxHeight: "50%",
        margin: "auto",
        display: "flex",
    },
};

class Login extends Component {
    state = {};

    resize = () => this.forceUpdate();

    componentWillUnmount() {
        window.removeEventListener("resize", this.resize);
    }

    componentDidMount() {
        window.addEventListener("resize", this.resize);
        this.props.loadActiveUser();
    }

    static getDerivedStateFromProps(nextProps) {
        if (nextProps.activeUser !== null) {
            nextProps.loadActiveUser();
            nextProps.history.replace("/");
        }

        return null;
    }

    success = (response) => {
        var userInfos = jwt_decode(response.credential);
        let email = this.props.testingUserEmail ?? userInfos.email;
        let token = response.credential;
        this.props.authenticateUser(email, token);
    };

    render() {
        const error = (response) => {
            console.error(response);
        };

        const loading = () => {
            console.warn("loading");
        };

        if (this.props.authenticateUserHasErrored) {
            return <p>{"Désolé ! Une erreur d'authentification s'est produite"}</p>;
        }

        if (this.props.authenticateUserIsLoading) {
            return <p>{"Chargement"}</p>;
        }

        let h = window.innerHeight > window.innerWidth;

        let paperContainer = {
            height: h ? "100vw" : "75vh",
            width: h ? "85vw" : "85vh",
            margin: h ? "8vw" : "8vh",
            zIndex: 2,
            position: "absolute",
        };

        return (
            <div className="div-center">
                <div
                    style={{
                        width: "100%",
                        minHeight: "calc(100vh - 55px)",//marge de la menuAppBar 55
                        height: "calc(100vh - 55px)",//marge de la menuAppBar 55
                        maxHeight: "200vh",
                        backgroundImage: "url(" + Background + ")",
                        backgroundSize: "cover",
                        backgroundPositionX: "50%",
                        overflow: "hidden",
                        position: "relative",
                    }}
                >
                    {h ? (
                        <svg
                            viewBox="0 0 100 200"
                            preserveAspectRatio="xMinYMin meet"
                            style={{
                                position: "absolute",
                                height: "200vw",
                                width: "100vw",
                                zIndex: 1,
                            }}
                        >
                            <path
                                d="M 85 20 L 100 32.5 L 100 157.5 L 20 87.5 Z"
                                fill="rgba(100, 100, 100, 0.21)"
                            />
                        </svg>
                    ) : (
                        <svg
                            viewBox="0 0 210 100"
                            preserveAspectRatio="xMinYMin meet"
                            style={{
                                position: "absolute",
                                height: "100vh",
                                width: "200vh",
                                zIndex: 1,
                            }}
                        >
                            <path
                                d="M 87.5 20 L 167.5 100 L 32.5 100 L 20 87.5 Z"
                                fill="rgba(100, 100, 100, 0.21)"
                            />
                        </svg>
                    )}
                    <Paper elevation={4} style={paperContainer}>
                        <div className="div-center logo-margin-top">
                            <img src={logo} alt="logo" style={styles.bgImage} />
                        </div>
                        <div style={styles.loginContainer} className="row login-container">
                            <div className="col-lg-12 col-md-12 col-sm-12 col-12 without-padding">
                                {!this.props.testingUserEmail ? (
                                    <div className="div-google-login">
                                        <NewGoogleLogin
                                            onSuccess={this.success.bind(this)}
                                            onError={() => {
                                                console.log('Login Failed');
                                            }}
                                        />
                                    </div>
                                ) : (
                                    <Button onClick={this.success.bind(this)} className="btn-google-login">
                                        Connexion
                                    </Button>
                                )}
                            </div>
                        </div>
                    </Paper>
                </div>
            </div>
        );
    }
}

// export default withRouter(Login)
const mapStateToProps = (state) => {
    return {
        authenticatedUser: state.authenticatedUser,
        authenticateUserHasErrored: state.authenticateUserHasErrored,
        authenticateUserIsLoading: state.authenticateUserIsLoading,
        activeUser: state.activeUser,
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        authenticateUser: (email, googleToken) => dispatch(authenticateUser(email, googleToken, getSynchroActiveUser, getDefaultSyncState, getAllData)),
        loadActiveUser: () => dispatch(loadActiveUser()),
    };
};
export default compose(
    withRouter,
    connect(mapStateToProps, mapDispatchToProps)
)(Login);
